/** Keyboard rules of the Story panel, the row menu and the picker (pure, 1.J deliverables 6, 7, 9). */

export interface MoveKeyEvent {
  readonly key: string;
  readonly altKey: boolean;
  readonly shiftKey: boolean;
  readonly ctrlKey: boolean;
  readonly metaKey: boolean;
  readonly isComposing?: boolean;
}

/** Alt-Shift-Up or Alt-Shift-Down: no Mod, not composing. */
export function isMoveKey(event: MoveKeyEvent): 'up' | 'down' | null {
  if (event.isComposing) return null;
  if (!event.altKey || !event.shiftKey || event.ctrlKey || event.metaKey) return null;
  if (event.key === 'ArrowUp') return 'up';
  if (event.key === 'ArrowDown') return 'down';
  return null;
}

/**
 * The index a key moves to in a list of `count` entries (wrapping), or `null` when the key does
 * not move. `active` is -1 when nothing is active yet.
 */
export function menuKeyTarget(key: string, active: number, count: number): number | null {
  if (count <= 0) return null;
  switch (key) {
    case 'ArrowDown':
      return active < 0 ? 0 : (active + 1) % count;
    case 'ArrowUp':
      return active <= 0 ? count - 1 : active - 1;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
}

/** The picker moves with the arrows and, with Ctrl, Home and End; Home and End edit text. */
export function pickerKeyTarget(
  key: string,
  active: number,
  count: number,
  ctrl = false,
): number | null {
  if ((key === 'Home' || key === 'End') && !ctrl) return null;
  return menuKeyTarget(key, active, count);
}
